<div class="container">
  <!-- Toast Notification -->
  <app-agricola-toast
    [message]="toastMessage"
    [type]="toastType"
    [show]="showToast"
    (close)="hideToast()">
  </app-agricola-toast>

  <div class="card">
    <app-agricola-stepper
      [steps]="steps"
      [currentStep]="selectedIndex"
      (backClick)="goBack()"
      (stepClick)="goToStep($event)">
    </app-agricola-stepper>

    <div class="info-banner" role="alert" *ngIf="showErrorBanner">
      <div class="info-banner-icon">
        <img src="assets/agricola/toast-warning.svg" alt="" aria-hidden="true">
      </div>
      <div class="info-banner-text">
        <span>{{ errorMessage || 'Revisa la información de dependientes para continuar.' }}</span>
      </div>
    </div>

    <div class="info-banner" role="status" *ngIf="showSuccessBanner">
      <div class="info-banner-icon">
        <img src="assets/agricola/toast-idea.svg" alt="" aria-hidden="true">
      </div>
      <div class="info-banner-text">
        <span>{{ successMessage }}</span>
        <button type="button" class="banner-close" aria-label="Cerrar mensaje" (click)="closeSuccessBanner()">×</button>
      </div>
    </div>

    <div class="insured-block">
      <!-- Título -->
      <div class="card">
        <h2 class="title-center">Ingresa los dependientes</h2>
      </div>

      <!-- Contenido principal -->
      <div class="card main-card">
        <div class="left-info">
          <p *ngIf="!isAssistance">
            <span class="label">Creación de producto:</span><br>
            Tipo de producto: {{ productTitle }}
          </p>
          <p *ngIf="isAssistance">
            <span class="label">Creación de asistencia:</span><br>
            Tipo de asistencia: {{ productTitle }}
          </p>
        </div>
      </div>

      <!-- Párrafo informativo -->
      <div class="card main-card">
        <p class="benef-info">
          <span class="label">Dependientes de la póliza</span><br>
          Puedes continuar sin dependientes. Este paso es opcional, si agregas uno o más, completa todos los campos requeridos.<br>
          <span class="label" *ngIf="maxDependants !== null">Máximo de dependientes: {{ maxDependants }}</span>
          <span class="label" *ngIf="maxDependants === null">Máximo de dependientes sin especificar</span>
        </p>
      </div>

      <!-- Lista de dependientes -->
      <div class="card" *ngIf="dependants.length > 0">
        <div class="benef-list">
          <div class="benef-item" *ngFor="let d of dependants.controls; let i = index">
            <div class="benef-content">
              <div class="benef-left">
                <div class="avatar">
                  <img src="assets/agricola/header-user.svg" alt="" aria-hidden="true">
                </div>
                <div class="benef-text">
                  <div class="benef-name">{{ d.get('name')?.value }}</div>
                  <div class="benef-meta">
                    {{ getRelationshipLabel(d.get('relationship')?.value) }} · ID {{ d.get('identification_id')?.value }}
                  </div>
                </div>
              </div>

              <div class="benef-actions">
                <button type="button" class="link" (click)="onDeleteDependant(i)">Eliminar</button>
                <button type="button" class="link" (click)="onEditDependant(i)">Editar</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botón añadir dependientes -->
      <div class="card">
        <button type="button"
                class="link-add"
                [disabled]="loadingRelationships || dependants.length >= effectiveMaxDependants"
                (click)="onAddDependant()">
          <img src="assets/agricola/beneficiarios.svg" alt="Añadir dependientes" class="icon-users" />
          {{ loadingRelationships ? 'Cargando parentescos...' : 'Añadir dependiente' }}
        </button>
      </div>
    </div>

    <!-- buttons -->
    <div class="actions">
      <app-sis-button variant="secondary" (pressed)="goBack()">Cancelar</app-sis-button>
      <app-sis-button (pressed)="onContinueClick()">Continuar</app-sis-button>
    </div>
  </div>

</div>
